export const settings = [
  {
    label: "Background color",
    type: "background-color",
    selector: "form",
    value: "#f9fafb"
  },
  {
    label: "Border radius",
    type: "border-radius",
    selector: "form",
    value: 4
  },
  {
    label: "Background image",
    type: "background-image",
    selector: "background",
    value: ""
  },
  {
    label: "Background transparency",
    type: "opacity",
    selector: "background",
    value: "0.2"
  },
  {
    group: "header",
    type: "color",
    selector: "header",
    value: "#4d4d4d"
  },
  {
    group: "header",
    type: "font-size",
    selector: "header",
    value: 27
  },
  {
    group: "header",
    type: "font-weight",
    selector: "header",
    value: 700
  },

  {
    group: "subheader",
    type: "color",
    selector: "subheader",
    value: "#686868"
  },
  {
    group: "subheader",
    type: "font-size",
    selector: "subheader",
    value: 18
  },
  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#000"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#e3e3e3"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 4
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#fff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#1677be"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 4
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 400
  },

  {
    group: "guarantee",
    type: "color",
    selector: "guarantee",
    value: "#4d4d4d"
  },
  {
    group: "guarantee",
    type: "font-size",
    selector: "guarantee",
    value: 13
  },
  {
    group: "guarantee",
    type: "font-weight",
    selector: "guarantee",
    value: 400
  }
]
